<script>
  import { isProxy, toRaw } from 'vue';
  export default {
    name: 'ProductListTextUnderBadge',
    props: {
      tags: Array,
      collectionId: String,
      badgeHideConfig: {
        type: Object,
        default: () => ({})
      },
      isPlp: {
        type: Boolean,
        default: false
      },
      price: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        badgeDetails: window.productBadges?.textBadge,
        badgeTag: '',
        color: '',
        isProcessing: false,
        rank: 15,
        showBadge: false,
        text: '',
        showOverrideBadge: false
      };
    },
    computed: {},
    mounted() {
      const overrideEventName = window.productBadges?.overrideEventName;
      if (overrideEventName) {
        window.addEventListener(overrideEventName, event => {
          this.showOverrideBadge = event.detail === true;
          this.setTag();
        });
        if (window.productBadges?.[overrideEventName] === true) {
          this.showOverrideBadge = true;
        }
      }
      this.setTag();
    },
    watch: {
      tags: function () {
        this.setTag();
      },
      price: function () {
        this.setTag();
      }
    },
    methods: {
      reset() {
        this.rank = 15;
        this.showBadge = false;
        this.color = '';
        this.text = '';
        this.badgeTag = '';
      },
      /**
       * Check if a badge should be hidden for the current collection
       * @param {string} badgeKey - Specific badge identifier
       * @returns {boolean} True if badge should be hidden
       */
      isHidden(badgeKey) {
        if (!this.badgeHideConfig?.textUnderPrice || !this.collectionId) return false;
        const badgeSet = this.badgeHideConfig.textUnderPrice[badgeKey];
        if (!badgeSet) return false;
        const normalizedCollectionId = this.collectionId.replace(/[\s_-]/g, '');
        return badgeSet.has(normalizedCollectionId);
      },
      setTag() {
        this.reset();
        if (this.isProcessing) {
          return;
        }
        this.isProcessing = true;
        requestAnimationFrame(() => {
          this.performTagUpdate();
          this.isProcessing = false;
        });
      },
      shouldShowOverrideText(badgeData) {
        if (this.showOverrideBadge === true && badgeData.text_override) {
          return badgeData.text_override;
        }
        return badgeData.text;
      },
      shouldShowOverrideColor(badgeData) {
        if (this.showOverrideBadge === true && badgeData.color_override) {
          return badgeData.color_override;
        }
        return badgeData.color;
      },
      performTagUpdate() {
        let badges = this.badgeDetails;
        if (isProxy(badges)) {
          badges = toRaw(badges);
        }
        let tags = this.tags;
        if (isProxy(tags)) {
          tags = toRaw(tags);
        }
        const matchingBadges = [];
        for (const key in badges) {
          const badgeTag = badges[key]['tag'];
          const found = tags.find(element => element === badgeTag);
          if (found) {
            matchingBadges.push({
              tag: badgeTag,
              rank: badges[key]['rank'],
              color: this.shouldShowOverrideColor(badges[key]),
              text: this.shouldShowOverrideText(badges[key]),
              showInPlp: badges[key]['showInPlp'],
              showInPdp: badges[key]['showInPdp'],
              discountPercent: badges[key]['discountPercent'] || null
            });
          }
        }
        if (matchingBadges.length === 0) {
          this.reset();
          return;
        }
        matchingBadges.sort((a, b) => a.rank - b.rank);
        for (const badge of matchingBadges) {
          if (this.isPlp && !badge.showInPlp) {
            continue;
          }
          if (!this.isPlp && !badge.showInPdp) {
            continue;
          }
          const badgeKey = `text_badge_tag_${badge.rank}`;
          const shouldHideThisBadge = this.isHidden(badgeKey);
          if (shouldHideThisBadge) {
            this.reset();
            return;
          }
          this.showBadge = true;
          this.rank = badge.rank;
          this.color = badge.color;
          this.text = this.applyDiscountToText(badge.text, badge.discountPercent);
          this.badgeTag = badge.tag;
          return;
        }
        this.reset();
      },
      applyDiscountToText(text, discountPercent) {
        if (!discountPercent || !this.price || !text || !text.includes('||new price||')) return text;
        const discounted = this.price * (1 - parseFloat(discountPercent) / 100);
        const formatted = new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(discounted).replace('.00', '');
        return text.replace(/\|\|new price\|\|/g, formatted);
      }
    }
  };
</script>

<template>
  <div v-if="showBadge && text" class="product__grid__title__wrapper promo-badge gt-p__small" :data-badge-tag="badgeTag">
    <div v-html="text" :style="'color:' + color"></div>
  </div>
</template>

<style lang="scss">
  .product__grid__title__wrapper.promo-badge {
    min-height: 20px;
  }

  .product__grid__title__wrapper.promo-badge:empty {
    display: none;
  }

  .product__grid__title__wrapper.promo-badge div {
    margin-bottom: 3px;
  }
</style>

